// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8ade716","455":"97d9618e","488":"23e8f503","977":"7e23b981"}[chunkId] + ".chunk.js";
};